export default function productsCardClassName(productsLayout, layout) {
  let className =
    productsLayout === 'compact'
      ? {
          mobile: 'col-xs-6',
          v1: 'col-xs-6 col-md-3',
          v2: 'col-xs-3 col-md-2'
        }[layout]
      : {
          mobile: 'col-xs-12',
          v1: 'col-xs-12 col-md-6',
          v2: 'col-xs-6 col-md-4'
        }[layout]
  className += ' menuProductCol'

  return className
}
